import React from 'react';

const StaffPageHeader = ({
  eyebrow = '',
  title,
  subtitle = '',
  actions = null,
  className = '',
  titleClassName = '',
  subtitleClassName = '',
}) => {
  return (
    <div className={`h-16 flex flex-col gap-3 md:flex-row md:items-center md:justify-between ${className}`.trim()}>
      <div className="space-y-1">
        {eyebrow ? (
          <p className="text-[11px] uppercase tracking-[0.16em] text-cyan-300 font-semibold">{eyebrow}</p>
        ) : null}
        <h1 className={`font-sans text-2xl lg:text-3xl font-bold text-slate-100 ${titleClassName}`.trim()}>{title}</h1>
        {subtitle ? (
          <p className={`text-sm lg:text-base text-slate-300 max-w-4xl ${subtitleClassName}`.trim()}>{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
};

export default StaffPageHeader;
